import React from "react";
import SectionHeader from "./SectionHeader";
import FadeIn from "./FadeIn";

export default function Skills() {
  const skillCategories = [
    {
      title: "Frontend",
      skills: ["TypeScript", "React", "Next.js", "TailwindCSS"],
    },
    {
      title: "Backend / Systems",
      skills: ["Rust", "Go", "C++", "C#", "Java", "Lua", "SQL"],
    },
    {
      title: "Runtimes & Data",
      skills: ["Node.js", "Bun", "Express", "PostgreSQL", "MongoDB"],
    },
    {
      title: "Dev Environment",
      skills: ["Linux", "Git", "Docker", "Neovim"],
    },
  ];

  return (
    <section id="skills" className="w-full py-28 md:py-36 px-6 md:px-12 bg-Base border-t hairline selection:bg-Sapphire selection:text-Base">
      <div className="max-w-4xl w-full mx-auto">
        <SectionHeader number="02" label="Capabilities" title="Skills" />

        <FadeIn>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-12">
          {skillCategories.map((category) => (
            <div key={category.title} className="border-t hairline pt-4">
              <h3 className="label-caps mb-5">{category.title}</h3>

              <ul className="space-y-2">
                {category.skills.map((skill) => (
                  <li key={skill} className="text-Text font-sans text-sm">
                    {skill}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        </FadeIn>
      </div>
    </section>
  );
}
